import { Icon, IconButton } from '@atom/mui';
import { CloseIcon, type IconComponent } from '@atom/mui/icons';

import sidebarClasses from './sidebars.module.css';

type SidebarMessageProps = {
  icon: IconComponent;
  message: string;
  onClose: () => void;
  variant?: 'default' | 'error';
};

const SidebarMessage = ({
  icon,
  message,
  onClose,
  variant = 'default',
}: SidebarMessageProps) => (
  <div className={sidebarClasses.messageContainer}>
    <div className={sidebarClasses.closeRow}>
      <IconButton tooltip="Close" onClick={onClose}>
        <Icon icon={CloseIcon} />
      </IconButton>
    </div>
    <div className={sidebarClasses.messageContent}>
      <Icon
        className={
          variant === 'error'
            ? sidebarClasses.messageIconError
            : sidebarClasses.messageIcon
        }
        icon={icon}
      />
      <div className={sidebarClasses.messageText}>{message}</div>
    </div>
  </div>
);

export default SidebarMessage;
